<template>

	<div class="page" style="max-width: 600px; margin: 0 auto;">
		<div style=" height: 100%; ">
			<div style="width:80%; margin:0 auto; padding-top: 10px;">
				<img src="https://school-saas.oss-cn-hangzhou.aliyuncs.com/files/2021-10-29/1635472999109932.png?s=1000_250"
					style="width: 100%; vertical-align: middle;" />

			</div>


			<div style="padding:40px">
				请点击下方【缴费】按钮，或使用微信扫描下方二维码查询报名状态并在线缴费
			</div>
			<div style="width:60%; margin:0 auto; padding-top: 0px;">
				<img src="/images/xjxxwk.jpg?v=1.0" style="width: 100%; vertical-align: middle;" />

			</div>
			<div class="btngo">
				<a :href="urlScheme" class="btna">去缴费</a>
			</div>


		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			urlScheme: ""
			///pages/wenjuan/wenjuan/wenjuan?f=sm&plan_id=xxx
			//wxc154c9fca4a1c193南卫去实习
		}
	},
	mounted() {
		document.title = "江苏省戏剧学校报名考试缴费通道"
		//plan_id要根据创建的来
		this.$http.post("/api/get_url_scheme", { pmid: 6 }).then(res => {
			this.urlScheme = res.data.urlScheme
		})

	},
	methods: {
		goNext() {

		}

	}
}
</script>

<style scoped>
.btngo {
	width: 80%;
	height: 36px;
	margin: 0 auto;
	background-color: #07c160;
	
	text-align: center;
	line-height: 36px;
	margin-top: 50px;
	border-radius: 4px;
}
.btngo:active{
	background-color: #079160;
}

.btna {
	display: inline-block;
	padding: 0;
	margin: 0;
	width: 100%;
	height: 100%;
	outline: none;
	text-decoration: none;
	color: #fff;
}
</style>
